import { render } from "./EmissionSourceMod.vue?vue&type=template&id=23a745c9&scoped=true"
import script from "./EmissionSourceMod.vue?vue&type=script&lang=js"
export * from "./EmissionSourceMod.vue?vue&type=script&lang=js"

import "./EmissionSourceMod.vue?vue&type=style&index=0&id=23a745c9&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a745c9"]])

export default __exports__